var map = {
	"./bg/background.jpg": "82ba",
	"./bg/example-promotion-detail.png": "eb41",
	"./bg/main-bg.jpg": "cd0f",
	"./example-menu.jpg": "ae48",
	"./fonts/DB Heavent Bd v3.2.ttf": "aebe",
	"./fonts/DB Heavent Med v3.2.ttf": "1964",
	"./fonts/DB Heavent Thin v3.2.ttf": "61f5",
	"./fonts/DB Heavent v3.2.ttf": "ff62",
	"./icon/Ticket Star.png": "b09e",
	"./icon/birthday-logo.png": "7b12",
	"./icon/check.png": "2aeb",
	"./icon/coupon.png": "2c05",
	"./icon/couponactive.png": "81d8",
	"./icon/history.png": "e4e6",
	"./icon/home.png": "9bf2",
	"./icon/homeactive.png": "9d80",
	"./icon/paper.png": "1b54",
	"./icon/profile.png": "2959",
	"./icon/profileactive.png": "8580",
	"./icons/arrange.png": "4b85",
	"./icons/c-flag-en.png": "e53b",
	"./icons/c-flag-thai.png": "b646",
	"./icons/couponblack.png": "4595",
	"./icons/filter.png": "02f6",
	"./icons/flag-aus.png": "7ff1",
	"./icons/flag-en.png": "0d60",
	"./icons/flag-ger.png": "4eb3",
	"./icons/flag-india.png": "d018",
	"./icons/flag-laos.png": "b477",
	"./icons/flag-myanmar.png": "8861",
	"./icons/flag-thai.png": "5953",
	"./icons/points.jpg": "7012",
	"./img/check_phone.jpg": "9bc4",
	"./img/completed-review.png": "7fbd",
	"./img/coupon-not-found.png": "94a2",
	"./img/crm-close.png": "2549",
	"./img/customer-feedback.png": "6d82",
	"./img/fridge.png": "1eec",
	"./img/fs-logo.png": "d8b5",
	"./img/icon-change-phone.jpg": "9ffe",
	"./img/no-branch-img.png": "3b84",
	"./img/no-reward.png": "a2e0",
	"./img/oops-error.webp": "2e7a",
	"./img/profile-interface-1.png": "db4ff",
	"./img/profile-interface-2.png": "4782",
	"./img/profile-interface-3.png": "61b5",
	"./img/reward.png": "5421",
	"./img/user-default.jpg": "76af",
	"./svg/arrow-down-circle.svg": "2745",
	"./svg/arrow-right-circle-gray.svg": "a0ef",
	"./svg/arrow-right-circle.svg": "1eb5",
	"./svg/background.svg": "9215",
	"./svg/bag.svg": "756d",
	"./svg/calendar-color.svg": "c67e",
	"./svg/calendar.svg": "76b2",
	"./svg/check.svg": "4a24",
	"./svg/coupon-active.svg": "d339",
	"./svg/coupon-expire.svg": "5e9a",
	"./svg/coupon-out.svg": "01e5",
	"./svg/coupon-use.svg": "96fa",
	"./svg/coupon-used.svg": "bc6d",
	"./svg/coupon.svg": "3f60",
	"./svg/description-icon.svg": "a38b",
	"./svg/discount.svg": "064c",
	"./svg/fridge.svg": "f8ec",
	"./svg/globe.svg": "716e",
	"./svg/history-icon.svg": "09eb",
	"./svg/home-active.svg": "2bad",
	"./svg/home.svg": "f2a5",
	"./svg/line_full_logo.svg": "ae5a",
	"./svg/line_logo.svg": "b281",
	"./svg/link.svg": "01df",
	"./svg/member-card.svg": "12f9",
	"./svg/no-phone-number.svg": "dcb2",
	"./svg/not-found.svg": "10cf",
	"./svg/phone-icon.svg": "2e4e",
	"./svg/phone.svg": "1f9a",
	"./svg/point-unit.svg": "d24c",
	"./svg/points.svg": "52d9",
	"./svg/privilege.svg": "9ddb",
	"./svg/profile-active.svg": "c198",
	"./svg/profile.svg": "1466",
	"./svg/refresh-1.svg": "a0db",
	"./svg/refresh.svg": "d47a",
	"./svg/restaurant.svg": "12b7",
	"./svg/search-no-data.svg": "da83",
	"./svg/ticket.svg": "cb57",
	"./svg/warning.svg": "45a1",
	"./svg/x.svg": "2f4c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";